import React from 'react';
import PropTypes from 'prop-types';

import './titlebar.scss';

const TitleBar = ({isLoggedIn, children}) => {
    return !isLoggedIn && (
        <div className="h1-bar">
            <h1 className="h1-bar__title">
                { children }
            </h1>
        </div>
    );
};

TitleBar.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    isLoggedIn: PropTypes.bool,
};

TitleBar.defaultProps = {
    children: '',
    isLoggedIn: true,
};

export default TitleBar;
